import {
  object,
  array,
  collection,
  number,
  string,
  boolean,
} from '@gogame/schemas';

import {
  EVENT,
  APPLICATION,
  BUSINESS_PARTNERS,
  TRAFFIC,
  TRAFFIC_TO_BUSINESS_PARTNER,
  AFFILIATES,
  STRATEGIES,
  IS_FINAL,
  REQUEST_URL,
  CONDITIONS,
  TARGET,
  ENTITIES,
  IS_ACTIVE,
  INCLUDE_REJECTED_REGS,
  ACTIVITY_TYPE,
  ACTIVITY_TYPE_TOTAL,
  REGISTRATION_COUNTRIES,
  EVENT_COUNTRIES,
} from './constants';

export const postbackStrategyConditionSchema = object({
  [TARGET]: number().required('Targeting is required'),
  [ENTITIES]: array(number()).required('Entities is required').default([]),
});

export const postbackStrategySchema = object({
  [IS_FINAL]: boolean(),
  [REQUEST_URL]: string().required('Request URL is required'),
  [CONDITIONS]: collection(postbackStrategyConditionSchema).default([
    postbackStrategyConditionSchema.default(),
  ]),
});

export const postbackSchema = object({
  [EVENT]: number().required('Event is required'),
  [APPLICATION]: number()
    .min(1, 'Application is required')
    .required('Application is required'),
  [BUSINESS_PARTNERS]: array(number()).required(
    'Business partners is required'
  ),
  [TRAFFIC]: number().default(TRAFFIC_TO_BUSINESS_PARTNER),
  [ACTIVITY_TYPE]: number().default(ACTIVITY_TYPE_TOTAL),
  [AFFILIATES]: array(number()),
  [STRATEGIES]: collection(postbackStrategySchema).default([
    postbackStrategySchema.default(),
  ]),
  [IS_ACTIVE]: boolean().default(true),
  [INCLUDE_REJECTED_REGS]: boolean(),
  [REGISTRATION_COUNTRIES]: array(number()),
  [EVENT_COUNTRIES]: array(number()),
});
